<template lang="pug">
  v-container(fluid grid-list-sm v-cloak)
    v-layout(row, wrap)
      v-flex(xs12)

        v-tabs(
          grow
          icons-and-text
          @input="activateTab($event)"
          :value="currentTab"
          slider-color="yellow"
          color="primary"
        )
          v-tab(href="#prepare")
            span {{$t('order.prepare.title')}}
            v-icon play_circle_outline

          v-tab(href="#input", :disabled="!progressing")
            span {{$t('order.input.title')}}
            v-icon create

          v-tab(href="#trial", :disabled="!progressing || !hasTrial")
            span {{$t('order.trial.title')}}
            v-icon build

          v-tab(href="#list", :disabled="isListEmpty || hasTrial")
            v-badge(color="deep-orange")
              span(slot="badge" v-if="!isListEmpty") {{totalRows}}
              span {{$t('order.list.title')}}
            v-icon view_list

          v-tab(href="#summary", :disabled="!progressing || hasTrial")
            span {{$t('order.summary.title')}}
            v-icon save

          v-tab(href="#quotation", :disabled="!progressing || isNewOrder")
            span {{$t('order.quotation.title')}}
            v-icon description

          v-tab-item#prepare
            v-card.flat
              v-card-text.pa-0
                order-prepare

          v-tab-item#input
            v-card.flat
              v-card-text.pa-0
                order-input

          v-tab-item#trial
            v-card.flat
              v-card-text.pa-0
                order-trial

          v-tab-item#list
            v-card.flat
              v-card-text.pa-0
                order-list

          v-tab-item#summary
            v-card.flat
              v-card-text.pa-0
                order-summary

          v-tab-item#quotation
            v-card.flat
              v-card-text.pa-0
                order-quotation

</template>

<script>
import OrderPrepare from '../Components/Prepare'
import OrderInput from '../Components/Input'
import OrderTrial from '../Components/Trial'
import OrderList from '../Components/List'
import OrderSummary from '../Components/Summary'
import OrderQuotation from '../Components/Quotation'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    OrderPrepare,
    OrderInput,
    OrderTrial,
    OrderList,
    OrderSummary,
    OrderQuotation
  },
  data () {
    return {}
  },
  created () {
    let self = this
    self.initializeOrder()
    if (self.isNewOrder) {
      return true
    }
    let token = self.$route.params.token
    self.$ajax.get(`order/load/${token}`).then(function (response) {
      let order = response.data.order
      if (order === null) {
        self.$toastr.warning('注文情報が見つかりませんでした。トップページに遷移します。')
        self.$router.push('/')
      }
      if (order.settled) {
        self.$toastr.warning('確定済みの注文情報は編集できません。トップページに遷移します。')
        self.$router.push('/')
      }
      self.setOrder(order.json)
      if (!order.json.summary.customer) {
        return true
      }
      self.startProgress()
      if (order.json.quotations.length === 0) {
        self.activateTab('summary')
      } else {
        self.activateTab('quotation')
      }
    })
  },
  beforeDestroy () {
    this.initializeOrder()
  },
  computed: {
    ...mapGetters('app/order', [
      'isNewOrder',
      'currentTab',
      'progressing',
      'hasTrial',
      'boxes',
      'isListEmpty',
      'totalRows'
    ])
  },
  methods: {
    ...mapActions('app/order', [
      'activateTab',
      'initializeOrder',
      'startProgress',
      'stopProgress',
      'clearStore',
      'setOrder'
    ])
  }
}
</script>

<style scoped lang="stylus">
</style>



// WEBPACK FOOTER //
// src/app/pages/Order/Estimate/index.vue